import type { ApiErrorShape } from "@/types";

export class ApiError extends Error implements ApiErrorShape {
  status: number;
  code: string;
  details?: unknown;
  constructor(opts: ApiErrorShape) {
    super(opts.message);
    this.status = opts.status;
    this.code = opts.code;
    this.details = opts.details;
  }
}

export function normalizeError(err: unknown): ApiError {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const anyErr = err as any;
  if (anyErr?.isAxiosError) {
    return new ApiError({
      status: anyErr.response?.status ?? 0,
      code: anyErr.response?.data?.code ?? anyErr.code ?? "NETWORK_ERROR",
      message: anyErr.response?.data?.message ?? anyErr.message ?? "Network error",
      details: anyErr.response?.data,
    });
  }
  if (err instanceof Error) {
    return new ApiError({ status: 0, code: "UNKNOWN", message: err.message });
  }
  return new ApiError({ status: 0, code: "UNKNOWN", message: "Unknown error" });
}
